const userAvatar = {
  validExtensions: ["jpg", "jpeg", "png"],
  maxSize: 5,
};

export default userAvatar;
